var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      ref: "dialog",
      staticClass: "com_dialog confirm_dialog",
      attrs: {
        title: _vm.dialogTitle,
        "append-to-body": true,
        visible: _vm.visibleDialog,
        "close-on-press-escape": _vm.closeOnPressEscape,
        "close-on-click-modal": _vm.closeOnClickModal,
        "before-close": _vm.handleClose,
        "custom-class": _vm.customClass,
        width: "460px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-body" }, [
        _c("div", { staticClass: "left" }, [
          _c("img", { attrs: { src: _vm.src, alt: "" } }),
        ]),
        _c("div", { staticClass: "right" }, [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          _c("div", { staticClass: "msg" }, [_vm._v(_vm._s(_vm.message))]),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "secondary" },
              on: { click: _vm.handleClose },
            },
            [_vm._v(_vm._s(_vm.cancelButtonText))]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: ["lock", "delete"].includes(_vm.type)
                  ? "warning"
                  : "primary",
              },
              on: { click: _vm.handleSure },
            },
            [_vm._v(_vm._s(_vm.confirmButtonText))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }